module.exports = __webpack_public_path__ + "img/historia.4f2d75c7.jpg";